import { render } from "./Wrap.vue?vue&type=template&id=1cbb7dd7&scoped=true"
import script from "./Wrap.vue?vue&type=script&lang=js"
export * from "./Wrap.vue?vue&type=script&lang=js"

import "./Wrap.vue?vue&type=style&index=0&id=1cbb7dd7&lang=less&scoped=true"

import exportComponent from "/builds/hp/demo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1cbb7dd7"]])

export default __exports__